import React from 'react';

import LoginIndex from '../../components/login/LoginIndex';

const LoginPage = () => {
  return <LoginIndex />;
};

export default LoginPage;
